import React, { Component } from 'react';
import PropTypes from 'prop-types';
import googleAnalyticsAction from '../../assets/js/analytics.js';

const propTypes = {
    data: PropTypes.object.isRequired
};

const beneficiaryDesignated = () => {
    googleAnalyticsAction('openBeneficiariesEditDesignate');
};

class BeneficiaryDesignationStatus extends Component {
    constructor(props) {
        super(props);

        this.state = props.data;
    }

    render() {
        let { completed, pending, completedDate, pendingDate } = this.state;

        return (
            <div className="asc-card-content asc-card-content--beny-designation">
                <span className="asc-card-subtitle">Beneficiary Designation Status</span>
                {completed && (
                    <div className="asc-card-content">
                        Completed as of {completedDate.toLocaleDateString()}
                        <a
                            className="asc-btn asc-btn--tertiary asc-btn--small"
                            href="../BeneficiaryDesignation.cfm"
                        >
                            View
                        </a>
                    </div>
                )}
                {pending && (
                    <div className="asc-card-content">
                        Pending as of {pendingDate.toLocaleDateString()}
                        <a
                            className="asc-btn asc-btn--tertiary asc-btn--small"
                            href="../BeneficiaryDesignation.cfm?showPending=true"
                        >
                            View
                        </a>
                    </div>
                )}
                {!completed && !pending && (
                    <div className="asc-card-content">
                        No Designation
                        <a
                            className="asc-btn asc-btn--tertiary asc-btn--small"
                            href="../BeneficiaryDesignation.cfm"
                            onMouseDown={beneficiaryDesignated}
                        >
                            Designate
                        </a>
                    </div>
                )}
            </div>
        );
    }
}
BeneficiaryDesignationStatus.propTypes = propTypes;
export default BeneficiaryDesignationStatus;
